module.exports = __webpack_public_path__ + "static/media/logo.581cd02a.webp";